
import React, { useCallback, useEffect, useState } from 'react'
import Default from '../CustomFields/Default'
import './FormPlugin.scss'
import useStateRef from 'react-usestateref'
import { useRef } from 'react'

const FormField = (props) => {
  const [fieldShowOrHide, setFieldShowOrHide, fieldShowOrHideRef] = useStateRef(false)
  const [fileError, setFileError] = useState("");
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const firstRenderRef = useRef(true);

  const labelMerger = (label) => {
    var mergedLabel = "";
    if (label.length != 0) {
      var splitedLabel = label.split(" ");
      if (splitedLabel) {
        splitedLabel.map((oneLabel) => {
          if (splitedLabel.indexOf(oneLabel) != 0) {
            // console.log("oneLabel",oneLabel);
            if (oneLabel) {
              let firstLetterUpperCase = oneLabel[0].toUpperCase();
              let labelSubStr = oneLabel.substr(1, oneLabel.length - 1);
              oneLabel = firstLetterUpperCase + labelSubStr;
            }
          }
          mergedLabel += oneLabel;
        })
      }
    }
    return mergedLabel;
  }

  const formatFieldName = (name, type = "camel") => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    if (type === "snake") {
      return words.map(w => w.toLowerCase()).join("_");
    }
    // camelCase (default)
    return words
      .map((word, index) => {
        word = word.toLowerCase();
        if (index === 0) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join("");
  };

  const renderWithLabelPosition = (position, labelNode, fieldNode, attributes) => {
    switch (position) {

      case "above":
        return (
          <>
            <div className="col-12 mb-2" style={{ textAlign: 'start' }}>{labelNode}</div>
            <div className="col-12">{fieldNode}</div>
          </>
        );

      case "right":
        return (
          <>
            <div className={attributes.formLabelTypeWidth || "col-md-3 col-12"}>
              {fieldNode}
            </div>
            <div className={attributes.formLabelWidth || "col-md-9 col-12"}>
              {labelNode}
            </div>
          </>
        );

      case "below":
        return (
          <>
            <div className="col-12">{fieldNode}</div>
            <div className="col-12 mt-1" style={{ textAlign: 'start' }}>{labelNode}</div>
          </>
        );

      // default → left
      default:
        return (
          <>
            <div className={attributes.formLabelWidth || "col-md-3 col-12"}>
              {labelNode}
            </div>
            <div className={attributes.formLabelTypeWidth || "col-md-9 col-12"}>
              {fieldNode}
            </div>
          </>
        );
    }
  };

  const textArea = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
      }
      if (eventLogic["hide"]) {
        setFieldShowOrHide(false)
      }
    }
    const labelPosition = props.attributes?.fieldToLablePosition || "left";
   // const fieldName = props?.attributes?.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");

    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );
    const fieldNode = (
      <textarea
        name={fieldName}
        className="form-control form-text-area"
        rows="3"
      />
    );
    return (
      
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 row px-2">
            {renderWithLabelPosition(labelPosition, labelNode, fieldNode, props.attributes)}
            <span id={`${fieldName}_error`}></span>
          </div>
        </div>
      </div>
    );
  };

  const text = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    const formFieldWidth = props?.attributes?.formFieldWidth;
    console.log("formFieldWidth",formFieldWidth);

    
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
      }
      if (eventLogic["hide"]) {
        setFieldShowOrHide(false)
      }
    }
    const labelPos = props?.attributes?.fieldToLablePosition || "left";
   // const fieldName = props?.attributes?.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");
    console.log("fieldName",fieldName);
    
    

    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );
    const fieldNode = (
      <>
        <input
          type="text"
          name={fieldName}
          className="form-control form-text-box"
          placeholder={`${props.attributes.fieldName} here..`}
        />
        {/* <span id={`${fieldName}_error`}></span> */}
      </>
    );

    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div id={fieldName} style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
          <div className="mt-2 row px-2">
            {renderWithLabelPosition(labelPos, labelNode, fieldNode, props.attributes)}
            <span id={`${fieldName}_error`}></span>
          </div>
        </div>
      </div>
    );
  };

  const email = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
      }
      if (eventLogic["hide"]) {
        setFieldShowOrHide(false)
      }
    }
    const labelPosition = props.attributes?.fieldToLablePosition || "left";
    //const fieldName = props?.attributes?.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");

    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );
    const fieldNode = (
      <input
        type="email"
        name={fieldName}
        className="form-control form-text-box"
        placeholder={`Enter ${props.attributes.fieldName}`}
        pattern='[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$'
      />
    );

    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 row px-2">
            {renderWithLabelPosition(labelPosition, labelNode, fieldNode, props.attributes)}
            <span id={`${fieldName}_error`}></span>
          </div>
        </div>
      </div>
    );
  };


  const password = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
      }
      if (eventLogic["hide"]) {
        setFieldShowOrHide(false)
      }
    }
    const labelPosition = props.attributes?.fieldToLablePosition || "left";
   // const fieldName=  props?.attributes?.fieldName
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");


    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );

    const fieldNode = (
      <input
        type="password"
        name={fieldName}
        className="form-control form-text-box"
        placeholder="Enter Password"
      />
    );
    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 row px-2">
            {renderWithLabelPosition(labelPosition, labelNode, fieldNode, props.attributes)}
            <span id={`${fieldName}_error`}></span>
          </div>
        </div>
      </div>
    );
  };

  const dropdown = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
      }
      if (eventLogic["hide"]) {
        setFieldShowOrHide(false)
      }
    }
    const optionsValue = Array.isArray(props.attributes.optionsValue)
      ? props.attributes.optionsValue
      : JSON.parse(props.attributes.optionsValue || "[]");
  
    const labelPosition = props.attributes?.fieldToLablePosition || "left";
   // const fieldName = props.attributes.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");

  
    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );
  
    const fieldNode = (
      <select
        className="form-select form-select-sm form-text-box"
        name={fieldName}
        field_Name={props?.attributes?.fieldName}
        onChange={handleDropDownValChange}
      
      >
        <option value="">Choose from Below</option>
        {optionsValue.map((item, index) => (
          <option key={index} value={item.inputValue}>
            {item.inputName}
          </option>
        ))}
      </select>
    );
  
    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 row px-2">
            {renderWithLabelPosition(
              labelPosition,
              labelNode,
              fieldNode,
              props.attributes
            )}
            <span id={`${fieldName}_error`}></span>
          </div>
        </div>
      </div>
    );
  };
  
  const handleDropDownValChange = (event) => {
    console.log("eventttttttttt------",event.target.getAttribute("field_Name"), props, event.target.value, event.target.name, event.target.field_Name)

    var value = event.target.value
    var name = event.target.name
    var field_Name = event.target.getAttribute("field_Name")
    props.handleShowFields(field_Name, value)
    props.handleHideFields(field_Name, value)
    

  }

  const richTextEditor = (props) => {
    const eventLogic =
      props.attributes.event &&
      props.attributes.event !== "" &&
      JSON.parse(props.attributes.event);
  
   // const fieldName = props.attributes.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");

    const labelName = props.attributes.labelValue;
  
    const sanitizeRichText = (html) => {
      if (!html) return "";
      return html
        .replace(/<p>/g, "<span>")
        .replace(/<\/p>/g, "</span>");
    };
  
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true);
      }
      if (eventLogic["hide"]) {
        setFieldShowOrHide(false);
      }
    }
  
    return (
      <div
        id={fieldName}
        style={{
          display: fieldShowOrHideRef.current ? "none" : "block",
          textAlign: "start",
        }}
        className="col-12"
      >
        <div className="mt-2 row">
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizeRichText(labelName),
            }}
          ></span>
          <span id={`${fieldName}_error`}></span>
        </div>
      </div>
    );
  };
  
  const handleRadioChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    var field_Name = event.target.getAttribute("field_Name")
    props.handleShowFields(field_Name, value);
    props.handleHideFields(field_Name, value);
  };


  const radioButton = (props) => {
    console.log("radio button props", props);
    const eventLogic =
      props.attributes.event &&
      props.attributes.event !== "" &&
      JSON.parse(props.attributes.event);

    if (eventLogic !== undefined) {
      if (eventLogic.show) {
        setFieldShowOrHide(true);
      }
      if (eventLogic.hide) {
        setFieldShowOrHide(false);
      }
    }

    const groupOfRadioButtonValue = Array.isArray(props.attributes.groupOfRadioButton)
      ? props.attributes.groupOfRadioButton
      : JSON.parse(props.attributes.groupOfRadioButton || "[]");

   // const fieldName = props.attributes.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");

    console.log("fieldName...",fieldName);
    
    // const [radioButtonValue, setRadioButtonValue] = useState("");

    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 d-flex flex-column align-items-start px-2">
          <label className="form-label mb-2">
            {props.attributes.label}
            {props.attributes.mandatoryField === "true" ? "*" : ""}
          </label>
            <input type="hidden" name={fieldName} value="" />
            {groupOfRadioButtonValue.map((item, index) => (
              <div
                key={index}
                className="form-check d-flex align-items-center me-3 mb-0"
              >
                <input
                  type="radio"
                  className="form-check-input mt-0"
                  name={fieldName}
                  field_Name={props?.attributes?.fieldName}
                  value={item.inputValue}
                  // checked={radioButtonValue === item.inputValue}
                  onChange={handleRadioChange}
                  id={labelMerger(item.inputName)}
                />
                <label
                  className="form-check-label ms-1 mb-0"
                  htmlFor={labelMerger(item.inputName)}
                >
                  {item.inputName}
                </label>
              </div>
            ))}

            {/* {!radioButtonValue && (
              <input type="hidden" name={fieldName} value="" />
            )} */}

            <span id={`${fieldName}_error`} className="ms-2"></span>
          </div>
        </div>
      </div>
    );
  };

  
  const checkBox = (props) => {
    console.log("checkBox,...",props);
    const eventLogic =
      props.attributes.event &&
      props.attributes.event !== "" &&
      JSON.parse(props.attributes.event);

    if (eventLogic !== undefined) {
      if (eventLogic.show) {
        setFieldShowOrHide(true);
      }
      if (eventLogic.hide) {
        setFieldShowOrHide(false);
      }
    }
    const groupOfcheckboxValue = JSON.parse(props.attributes.groupOfCheckBox);

    const [checkboxInfo, setCheckboxInfo] = useState({
      checkedValues: [],
      response: [],
    });
    const [checkBoxValue, setCheckBoxValue, checkBoxValueRef] = useStateRef(false);
    const handleChange = (event) => {
      setCheckBoxValue(true);
      var field_Name = event.target.getAttribute("field_Name")
      const { value, checked, name } = event.target;
      const { checkedValues } = checkboxInfo;

      let updatedValues = [];

      if (checked) {
        updatedValues = [...checkedValues, value];
      } else {
        updatedValues = checkedValues.filter((v) => v !== value);
      }
      setCheckboxInfo({
        checkedValues: updatedValues,
        response: updatedValues,
      });
      props.handleShowFields(field_Name, updatedValues);
      props.handleHideFields(field_Name, updatedValues);
    };

    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");

    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 d-flex align-items-center flex-wrap px-2">
            <label className="form-label mb-0 me-3">
              {props.attributes.label}
              {props.attributes.mandatoryField === "true" ? "*" : ""}
            </label>
            {groupOfcheckboxValue.map((item, index) => (
              <div className={`form-check me-3 d-flex align-items-center ${props?.attributes?.class || ""}`} key={index}>

                <input
                  type="checkbox"
                  onChange={handleChange}
                  field_Name={props?.attributes?.fieldName}
                  name={fieldName}
                  className="form-check-input"
                  id={labelMerger(item.inputName)}
                  value={item.inputValue}
                />

                <label
                  className="form-check-label ms-1 mb-0"
                  htmlFor={labelMerger(item.inputName)}
                >
                  {item.inputName}
                </label>

              </div>
            ))}

          </div>

        </div>


      </div>
    );
    }

    const handleInvalid = (e) => {
      const fieldName = e.target.name;
      e.target.classList.add("is-invalid");
      const errorEl = document.getElementById(`${fieldName}_error`);
      // if (errorEl) {
      //   errorEl.innerText = "This field is required";
      // }
    };
    
    // const handleInput = (e) => {
    //   const fieldName = e.target.name;
    //   e.target.classList.remove("is-invalid");
    //   const errorEl = document.getElementById(`${fieldName}_error`);
    //   if (errorEl) {
    //     errorEl.innerText = "";
    //   }
    // };


    const handleInput = async (e) => {
      const fieldName = e.target.name;
      const value = e.target.value;
      e.target.classList.remove("is-invalid");
      const errorEl = document.getElementById(`${fieldName}_error`);
      if (errorEl) {
        errorEl.innerText = "";
      }
    
      if (fieldName === "country") {
       setSelectedCountry(value);  
        setStates([]);
        try {
          const response = await fetch(`/fetch-states-by-country?country=${value}`);
          const data = await response.json();
          setStates(data.results || []);
         
    
        } catch (error) {
          console.log("State fetch error", error);
        }
      }
    };


    const fieldConfig = {
      address1: {
        label: "Address Line 1",
        type: "text",
        col: "col-12",
        required: true
      },
      address2: {
        label: "Address Line 2",
        type: "text",
        col: "col-12",
        required: false
      },
      city: {
        label: "City",
        type: "text",
        col: "col-md-6",
        required: true
      },
      state: {
        label: "State / Province",
        type: "select",
        col: "col-md-6",
        required: true,
        options: []   
      },
      postal: {
        label: "Postal / Zip Code",
        type: "text",
        col: "col-md-6",
        required: true
      },
      country: {
        label: "Country",
        type: "select",
        col: "col-md-6",
        required: true,
        options: ["IND", "USA"],
        
      }
    };

  const address = (props) => {
    const eventLogic =
    props.attributes.event &&
    props.attributes.event !== "" &&
    JSON.parse(props.attributes.event);

  if (eventLogic !== undefined) {
    if (eventLogic.show) {
      setFieldShowOrHide(true);
    }
    if (eventLogic.hide) {
      setFieldShowOrHide(false);
    }
  }
    console.log("inside the address props...", props.attributes?.formObj?.attributes?.AddressGroup);
    const fields = props.attributes?.formObj?.attributes?.AddressGroup?.split(",").map((f) => f.trim()) || [];
    const labelPos = props?.attributes?.fieldToLablePosition || "left";
    //const fieldName = props?.attributes?.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");
    const isMandatory = props.attributes.mandatoryField === "true";
    console.log("fields:", fields);
    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );

    const renderField = (field, index) => {
      const config = fieldConfig[field];
      if (!config) return null;
      const halfFields = ["city", "state", "postal", "country"];

      const visibleHalfFields = fields.filter((f) => halfFields.includes(f));
      const halfIndex = visibleHalfFields.indexOf(field);
    
      let columnClass = config.col;
    
      if (halfFields.includes(field)) {
        if (visibleHalfFields.length % 2 !== 0 && halfIndex === visibleHalfFields.length - 1) {
          columnClass = "col-12";
        } else {
          columnClass = "col-md-6";
        }
      }
    
      return (
        <div className={`${columnClass} mt-2`}>
          {config.type === "select" ? (
              <select
              name={field}
              className="form-control"
              required={isMandatory && config.required}
              onInvalid={handleInvalid}
              onChange={handleInput}
              value={field === "country" ? selectedCountry : undefined}
            >
              <option value="">Please Select</option>
            
              {(field === "state" ? states : config.options)?.map((opt) => (
                <option
                  key={field === "state" ? opt.geoId : opt}
                  value={field === "state" ? opt.geoId : opt}
                >
                  {field === "state" ? opt.geoName : opt}
                </option>
              ))}
            
            </select>
          ) : (
            <input
              type="text"
              name={field}
              className="form-control"
              required={isMandatory && config.required}
              onInvalid={handleInvalid}
              onInput={handleInput}
            />
          )}
    
          <small
            className="text-muted d-block mt-1"
            style={{ textAlign: "left" }}
          >
            {config.label}
          </small>
    
          {config.required && (
            <span id={`${field}_error`} className="error-text"></span>
          )}
        </div>
      );
    };
    const fieldNode = (
      <div className="row">
        {fields.map((field) => renderField(field))}
      </div>
    );
    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
         <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
        <div className="mt-2 row px-2">
          {renderWithLabelPosition(labelPos, labelNode, fieldNode, props.attributes)}
        </div>
        </div>
      </div>
    );
  };

  const file = (props) => {
    console.log("file props", props);
    const eventLogic =
      props.attributes.event &&
      props.attributes.event !== "" &&
      JSON.parse(props.attributes.event);
  
    if (eventLogic !== undefined) {
      if (eventLogic.show) {
        setFieldShowOrHide(true);
      }
      if (eventLogic.hide) {
        setFieldShowOrHide(false);
      }
    }
  
    const labelPosition = props.attributes?.fieldToLablePosition || "left";
    //const fieldName = props.attributes.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");
    const uploadFileType = props?.attributes?.uploadFileType || ".pdf";
    const fileSize = props?.attributes?.fileSize || "2MB";
    console.log("fileSize...",fileSize);
    
    console.log("uploadFileType",uploadFileType);
    
    const allowedExtensions = uploadFileType
      .split(",")
      .map((ext) => ext.trim().toLowerCase());
  
    const acceptAttr = allowedExtensions.join(",");
  
    const [selectedFiles, setSelectedFiles] = useState({});
    const [fileError, setFileError] = useState("");
    const fileInputRef = useRef(null);
  
    useEffect(() => {
      setSelectedFiles({});
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }, [props.reset]);
    
    
    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );
  
    // Convert "2MB" or "500KB" to bytes
    const parseFileSize = (sizeStr) => {
      const size = sizeStr.toUpperCase();
      const num = parseFloat(size);
  
      if (size.includes("KB")) return num * 1024;
      if (size.includes("MB")) return num * 1024 * 1024;
      if (size.includes("GB")) return num * 1024 * 1024 * 1024;
  
      return num;
    };
  
    const maxSizeBytes = parseFileSize(fileSize);
  
    const isValidFile = (file) => {
      if (!file) return false;
    
      const ext = "." + file.name.split(".").pop().toLowerCase();
    
      if (!allowedExtensions.includes(ext)) {
        setFileError(`Only ${acceptAttr} files are allowed`);
        return false;
      }
    
      if (file.size > maxSizeBytes) {
        setFileError(`File size must be less than ${fileSize}`);
        return false;
      }
    
      setFileError(""); // clear error
      return true;
    };
  
    const handleButtonClick = () => {
      fileInputRef.current?.click();
    };
  
    const handleFileChange = (e) => {
      const file = e.target.files?.[0];
    
      if (!file) return;
    
      if (!isValidFile(file)) {
        e.target.value = "";
        return;
      }
    
      setFileError("");
    
      setSelectedFiles({
        [fieldName]: file,
      });
    };
  
    const handleDrop = (e) => {
      e.preventDefault();
      const file = e.dataTransfer.files?.[0];
    
      if (!file) return;
    
      if (!isValidFile(file)) return;
    
      setFileError("");
    
      const dt = new DataTransfer();
      dt.items.add(file);
    
      if (fileInputRef.current) {
        fileInputRef.current.files = dt.files;
      }
    
      setSelectedFiles({
        [fieldName]: file,
      });
    };
    const handleDelete = () => {
      setSelectedFiles({});
      setFileError("");
    
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };
  
    const formatFileSize = (size) => {
      if (size < 1024) return size + " B";
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
      return (size / 1024 / 1024).toFixed(2) + " MB";
    };
  
    const fieldNode = (
      <>
        <input
          key={props.reset ? "reset1" : "reset0"}
          type="file"
          ref={fileInputRef}
          name={fieldName}
          className="d-none"
          accept={acceptAttr}
          onChange={handleFileChange}
        />
  
        <div
          className="p-4 rounded-4 border border-2 text-center bg-light upload-dashed"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <i className="bi bi-cloud-arrow-up fs-1 mb-2 text-primary"></i>
  
          <h6 className="fw-semibold mt-2 mb-1">
            Drag & drop a file here
          </h6>
  
          <span className="text-secondary small d-block my-2">
            OR
          </span>
  
          <button
            type="button"
            className="btn btn-outline-secondary rounded-pill px-4"
            onClick={handleButtonClick}
          >
            Browse Files
          </button>
  
          <span className="text-muted small d-block mt-2">
            Allowed file types: <strong>{acceptAttr}</strong>
          </span>
  
          <span className="text-muted small d-block mt-1">
            File Size: <strong>{fileSize}</strong>
          </span>
          {fileError && (
            <div className="text-danger mt-2 small fw-semibold">
              {fileError}
            </div>
          )}
        </div>
      
  
        {selectedFiles[fieldName] && (
          <div className="mt-3 d-flex justify-content-between align-items-center bg-light p-3 rounded shadow-sm border">
            <span className="text-success fw-semibold">
              {selectedFiles[fieldName].name}
            </span>
  
            <div className="d-flex align-items-center gap-3">
              <span className="text-success">
                {formatFileSize(selectedFiles[fieldName].size)}
              </span>
  
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={handleDelete}
              >
                <i className="bi bi-trash"></i>
              </button>
            </div>
          </div>
        )}
  
      </>
    );
  
    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
        <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
          <div className="mt-2 row">
            {renderWithLabelPosition(
              labelPosition,
              labelNode,
              fieldNode,
              props.attributes
            )}
             <span id={`${fieldName}_error`}></span>
          </div>
        </div>
      </div>
    );
  };
  const phone = (props) => {

    console.log("phone props", props);
    const eventLogic =
      props.attributes.event &&
      props.attributes.event !== "" &&
      JSON.parse(props.attributes.event);

      console.log("eventLogic phone...",eventLogic);
      
    if (eventLogic !== undefined) {
      if (eventLogic.show) {
        setFieldShowOrHide(true);
      }
      if (eventLogic.hide) {
        setFieldShowOrHide(false);
      }
    }

    const formatExample =
      props?.attributes?.phoneNumberType || "(###) ###-####";
   // const fieldName = props?.attributes?.fieldName;
    const fieldName = formatFieldName(props?.attributes?.fieldName, "camel");
    const labelPos = props?.attributes?.fieldToLablePosition || "left";
    const [rawValue, setRawValue] = React.useState("");
    const maxDigits = (formatExample.match(/[#Xx]/g) || []).length;
    const displayPlaceholder = formatExample.replace(/[#Xx]/g, "0");

    const applyFormat = (digits) => {
      if (!digits) return "";  
      const cleaned = digits.substring(0, maxDigits);

      let result = "";
      let digitIndex = 0;

      for (let char of formatExample) {
        if (/[#Xx]/.test(char)) {
          if (digitIndex < cleaned.length) {
            result += cleaned[digitIndex++];
          } else {
            break;
          }
        } else {
          result += char;
        }
      }

      return result;
    };
    const handleChange = (e) => {
      const onlyDigits = e.target.value.replace(/\D/g, "");
      setRawValue(onlyDigits);
    };

    const formattedValue = applyFormat(rawValue);

    const labelNode = (
      <label>
        {props.attributes.label}
        {props.attributes.mandatoryField === "true" ? "*" : ""}
      </label>
    );

    const fieldNode = (
      <>
        <input
          type="tel"
          name={fieldName}
          className="form-control form-text-box"
          value={formattedValue}
          placeholder={displayPlaceholder}
          inputMode="numeric"
          onChange={handleChange}
        />
       
      </>
    );

    return (
      <div className={props.attributes.formFieldWidth || "col-12"}>
         <div
          id={fieldName}
          style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}
        >
        <div className="mt-2 row px-2">
          {renderWithLabelPosition(
            labelPos,
            labelNode,
            fieldNode,
            props.attributes
          )}
           <span id={`${fieldName}_error`}></span>
        </div>
        </div>
      </div>
    );
  };

  const components = {
    textArea: textArea,
    text: text,
    checkBox: checkBox,
    radioButton: radioButton,
    email: email,
    password: password,
    dropdown: dropdown,
    label: richTextEditor,
    richTextEditor: richTextEditor,
    Default: Default,
    file:file,
    phone:phone,
    address:address,
  }

  var formObj = components[props.type];
  const RenderType = formObj ? formObj : components['Default'];
  return (
    <RenderType attributes={props} />
  )

}

export default FormField

